import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_movewithtony/artifacts/0c98olj8_c413a017a11bcba_file_000000009aec61fba9d62adbd361f5c9_wm.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "About", path: "/about" },
    { name: "Reviews", path: "/reviews" },
    { name: "Contact", path: "/contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="Tony Moves It" 
              className="h-14 w-14 object-contain rounded-lg"
            />
            <div className="hidden sm:block">
              <span className="text-2xl font-bold text-[#0047AB] font-['Barlow_Condensed']">TONY MOVES IT</span>
              <p className="text-xs text-slate-500">Cornwall & SDG Moving Experts</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase()}`}
                className={`font-semibold transition-colors ${
                  isActive(link.path)
                    ? "text-[#0047AB]"
                    : "text-slate-600 hover:text-[#0047AB]"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-4">
            <a 
              href="tel:613-362-8180" 
              className="flex items-center gap-2 text-slate-600 hover:text-[#0047AB] font-medium"
              data-testid="phone-link"
            >
              <Phone className="w-4 h-4" />
              <span>613-362-8180</span>
            </a>
            <Link to="/quote" data-testid="nav-quote-btn">
              <Button className="bg-[#0047AB] hover:bg-[#003380] text-white font-bold">
                Free Quote
              </Button>
            </Link>
            <Link to="/booking" data-testid="nav-book-btn">
              <Button className="bg-slate-600 hover:bg-slate-700 text-white font-bold">
                Book Now
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4" data-testid="mobile-menu">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`font-semibold py-2 ${
                    isActive(link.path)
                      ? "text-[#0047AB]"
                      : "text-slate-600"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <hr className="border-slate-200" />
              <a 
                href="tel:613-362-8180" 
                className="flex items-center gap-2 text-slate-600 font-medium py-2"
              >
                <Phone className="w-4 h-4" />
                <span>613-362-8180</span>
              </a>
              <Link to="/quote" onClick={() => setIsOpen(false)}>
                <Button className="w-full bg-[#0047AB] hover:bg-[#003380] text-white font-bold">
                  Free Quote
                </Button>
              </Link>
              <Link to="/booking" onClick={() => setIsOpen(false)}>
                <Button className="w-full bg-slate-600 hover:bg-slate-700 text-white font-bold">
                  Book Now
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
